import styled from "styled-components";

import Button from "@8x8/oxygen-button";

import { CopyButton } from "@/react/components/CopyButton";
import { InnerContainer } from "@/react/features/support-tools/common/styled";

export const ComparisonArea = styled.div`
  display: flex;
  flex-direction: row;
  gap: 10px;
`;

export const TextAreaWrapper = styled.div`
  display: flex;
  position: relative;
  flex: 1;
`;

export const MainContainer = styled(InnerContainer)`
  display: flex;
  flex-direction: column;
  flex-grow: 0;
  gap: 10px;
`;

export const SubmitButton = styled(Button)`
  align-self: center;
`;

export const CopyTextButton = styled(CopyButton)`
  display: flex;
  position: absolute;
  top: 5px;
  right: 5px;
`;
